import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {withRouter} from 'react-router-dom';
import Image from './Image'
import logo from '../../assets/new-udrive-logo.svg';
import NavLink from './NavLink';
import {textProvider} from './imports';


const CLASS_NAMES = {
    SIDEBAR_WRAPPER: 'sidebar-wrapper',
    SIDEBAR_MENU: 'sidebar-menu',
    SIDEBAR_MENU_ITEM: 'sidebar-menu-item',
    SIDEBAR_MENU_ITEM_DISABLED: 'sidebar-menu-item--disabled',
    SIDEBAR_MENU_ITEM_ACTIVE: 'sidebar-menu-item--active',
    SIDEBAR_ACTIVE_MENU_ITEM: 'sidebar-active-menu-item',
    SIDEBAR_LOGO_WRAPPER: 'sidebar-logo-wrapper',
    SIDEBAR_LOGO_TEXT: 'sidebar-logo-text',
    SIDEBAR_MENU_TITLE: 'sidebar-menu-title',
};

const TEXTS = {
    UDRIVE: textProvider.getText('sideBar', 'udrive'),
    OVERVIEW: textProvider.getText('sideBar', 'overview'),
}

const Sidebar = (props) => {
    const {filteredRoutes, publisherId, disabledMenu, location} = props;

    return (
        <div className={CLASS_NAMES.SIDEBAR_WRAPPER}>
            <div className={CLASS_NAMES.SIDEBAR_LOGO_WRAPPER}>
                <img src={logo} alt='UdriveLogo' className={CLASS_NAMES.SIDEBAR_LOGO_IMG} />
                <div className={CLASS_NAMES.SIDEBAR_LOGO_TEXT}>{TEXTS.UDRIVE}</div>
            </div>
            <div className={CLASS_NAMES.SIDEBAR_MENU_TITLE}>{TEXTS.OVERVIEW}</div>
            <ul className={CLASS_NAMES.SIDEBAR_MENU}>
                {filteredRoutes.map((route, index) => {
                    const routePath = `/${publisherId}${route.url}`;
                    const isMenuActive = location.pathname === routePath;
                    return (route.url !== '/' && route.isEnabled) && (
                        <li key={index}
                            className={cx(CLASS_NAMES.SIDEBAR_MENU_ITEM,
                                {
                                    [CLASS_NAMES.SIDEBAR_MENU_ITEM_DISABLED]: disabledMenu,
                                    [CLASS_NAMES.SIDEBAR_MENU_ITEM_ACTIVE]: isMenuActive
                                })}
                        >
                            <NavLink to={`/${publisherId}${route.url}`}
                                     activeClassName={cx({[CLASS_NAMES.SIDEBAR_ACTIVE_MENU_ITEM]: isMenuActive})}
                            >
                                <Image name={isMenuActive ? route.imgActive : route.img}
                                       hookId={`${route.url.slice(1)}-menu-item-icon`}
                                />
                                {route.displayName}
                            </NavLink>
                        </li>
                    )
                })}
            </ul>
        </div>
    );
};

Sidebar.propTypes = {
    filteredRoutes: PropTypes.array,
    disabledMenu: PropTypes.bool,
    publisherId: PropTypes.number
};

export default withRouter(Sidebar);
